<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="col-12 mb-50">

        </div>
        <div class="col-md-6 col-12 row">
            <div class="d-flex justify-content-between align-items-center ml-1">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
            <div>
                <button type="button" class="btn btn-flat-success d-flex align-items-center"
                    (click)="createDevice(companyId)">
                    <span data-feather="plus"></span>
                    Cihaz Ekle
                </button>
            </div>
        </div>

    </div>
    <ngx-datatable [rows]="rows" #tableRowDetails [rowHeight]="50" class="bootstrap core-bootstrap"
        style="cursor: pointer;" [limit]="selectedSize" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true"
        [rowHeight]="'auto'">

        <ngx-datatable-row-detail [rowHeight]="getRowHeight">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                <div class="ml-3 pl-4 pt-2">
                    <table class="table table-responsive table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>İşlem Yapan Kişi</th>
                                <th>Tür</th>
                                <th>Hareket Tarihi</th>
                                <th>Açıklama</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let movement of deviceMovements; let index = index;">
                                <td>{{index + 1}}</td>
                                <td>{{ movement?.name }} {{ movement?.lastName }}</td>
                                <td>{{ movement?.typeName }}</td>
                                <td>{{ movement?.movementDate | date: 'dd.MM.yyyy' }}</td>
                                <td>{{ movement?.description }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </ngx-datatable-row-detail>

        <ngx-datatable-column [width]="100" [resizeable]="false" [sortable]="false" [draggable]="false"
            [canAutoResize]="false">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
                    [class.datatable-icon-down]="expanded" title="Expand/Collapse Row"
                    (click)="rowDetailsToggleExpand(row)">
                </a>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Sorumlu Kişi" prop="name" [width]="50" class="ellipsis-column">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.name}} {{row.lastName}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Tür" prop="typeName" class="ellipsis-column"></ngx-datatable-column>
        <ngx-datatable-column name="Marka Model" class="ellipsis-column">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.brandName}} {{row.modelName}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="#" [width]="40" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <!-- stopPropagation burada ekleniyor -->
                    <button class="btn btn-icon btn-flat-warning" (click)="updateDevice(row.id,companyId, $event)">
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>